import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { ApplicationEmptyState, GlobalSignalRListener, BaasicButton, BaasicConfirmModal, BaasicDropdown, ScrollToTopButton, BaasicDraggableModal, BaasicModal } from 'core/components';
import { PreviewLayout } from 'core/layouts';
import { ItemActionTriangle } from 'themes/components';
import { orderingDoctorItemRender, orderingDoctorValueRender } from 'themes/components/select/OrderingDoctorDropdownRender';
import { NikoFacilityOrderStatusBar, NikoFacilityOrderReasonForChangeModal, NikoFacilityOrderConfirmationModal, NikoFacilityOrderPatientTemplateNoteModal } from "application/niko-facility-order/components";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { DropDownButton, DropDownButtonItem, Button } from "@progress/kendo-react-buttons";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import moment from "moment";
import { observer } from "mobx-react";
import { NikoPatientInformationBar, NikoPatientInsuranceQuestionModal, NikoPatientInsuranceInfoNoteModal, NikoPatientEligibilityStatusNoteModal, NikoTemplateCreateModal, NikoTemplateMissingProductNoteModal, NikoTemplateInvoiceNoteModal, NikoPatientStatusModal, NikoPatientTemplateItemCalculationModal, NikoTemplateMissingDocumentNoteModal, PatientTemplateClinicalStatusNoteModal, PatientTemplateCustomOrderingDoctorAdd, NikoCreateNewPatientModal } from "application/niko-patient/components";
import { toDate, handleKeyDown, handlePaste, uuid } from "core/utils";
import { FacilityOrderTemplateNewFlowDeleteModal, FacilityOrderTemplateItemNewFlowDeleteQuestionModal } from "application/facility-order-new-flow/components";
import { FacilityOrderTemplatePNMissingInformationModal } from "application/facility-order/components";
import { NikoFacilityOrderUSIntakeFindAndReplaceModal } from 'application/niko-facility-order-us-intake/components';
import { NikoFacilityOrderNewFlowExtraSuppliesAddModal } from "application/niko-facility-order-inventory/components";

function NikoFacilityOrderClinicalReviewPreviewTemplate({ nikoFacilityOrderClinicalReviewPreviewViewStore }) {
  const {
    loaderStore,
    refreshKey,
    goToFacilityPreview,
    goToFacilityCalendar,
    tabItems,
    selectedStatusAbrv,
    setStatus,
    startClinicalReview,
    disabledByStatus,
    disabledBySendOrder,
    filterByQuestion,
    filterByCategory,
    questionsStore,
    selectedQuestions,
    itemCategoryStore,
    itemCategories,
    fetchingData,
    disabled,
    statusConfirmModal,
    clinicalReviewStatus,
    usIntakeStatus,
    nikoPatientDetails,
    isReviewed,
    isEmpty,
    isDocumentationRequestSent,
    hasMissingDocuments,
    setClinicalReviewCompleted,
    documentationRequestCreate,
    nikoPatientInsuranceQuestionModal,
    nikoPatientInsuranceInfoNoteModal,
    nikoPatientEligibilityStatusNoteModal,
    nikoTemplateCreateModal,
    nikoTemplateMissingProductNoteModal,
    nikoTemplateInvoiceNoteModal,
    patientTemplateDoNotSupplyModal,
    patientTemplateDiscontinuedModal,
    nikoPatientStatusModal,
    patientTemplateDeleteModal,
    nikoPatientTemplateItemCalculationModal,
    nikoFacilityOrderReasonForChangeModal,
    nikoPatientTemplateItemNewFlowDeleteQuestionModal,
    orderHistory,
    isHistoryVisible,
    templateChangeConfirmModal,
    rootStore,
    id,
    signalRAction,
    facilityOrder,
    openNikoFacilityOrderFindAndReplaceModal,
    nikoFacilityOrderFindAndReplaceModal,
    nikoFacilityOrderNewFlowExtraSuppliesAddModal,
    patientTemplateClinicalStatusNoteModal,
    nikoTemplateMissingDocumentNoteModal,
    templatePNMissingInformationModal,
    downloadInventoryReport,
    insuranceCoverageStatusOverviewEmailEdit,
    isInventoryStepAllowed,
    patientTemplateNoteModal,
    nikoCreateNewPatientModal,
    openCreateNewPatientModal,
    documentationRequestConfirmModal,
    notification,
    creatingNikoSOs,
    createNikoSOs,
    creatingNikoInvoices,
    createNikoInvoices,
    invoiceSalesOrderLinkConfirmModal
  } = nikoFacilityOrderClinicalReviewPreviewViewStore;

  const handleActionDropDownItemsOnClick = (e) => {
    if (e.item.text === "New Patient") {
      openCreateNewPatientModal();
    }
    else if (e.item.text === "Overview Email") {
      insuranceCoverageStatusOverviewEmailEdit();
    }
    else if (e.item.text === "Documentation Request") {
      documentationRequestCreate();
    }
    else if (e.item.text === "Inventory Report") {
      downloadInventoryReport();
    }
    else if (e.item.text === "Find and Replace") {
      openNikoFacilityOrderFindAndReplaceModal();
    }
    else if (e.item.text === "Create Niko SOs") {
      createNikoSOs();
    }
    else if (e.item.text === "Create Niko Invoices") {
      createNikoInvoices();
    }
  }

  return (
    <PreviewLayout className="container container--new-flow" store={nikoFacilityOrderClinicalReviewPreviewViewStore} emptyRenderer={<ApplicationEmptyState />} layoutFooterVisible={false} loading={loaderStore.loading}>
      <ReactTooltip positionStrategy="fixed" id="clinicalReviewTooltip" place="bottom" />
      <GlobalSignalRListener groupId={id} rootStore={rootStore} action={signalRAction} />
      {notification &&
        <div className='message__bar'>
          <span>{notification} </span><a href="#" onClick={() => window.location.reload()} title="Reload Page" className='message__bar__btn'>Reload</a>
        </div>
      }
      {facilityOrder && facilityOrder.facility && <NikoFacilityOrderStatusBar key={refreshKey} title={`${facilityOrder.facility.name} - DOS ${toDate(facilityOrder.dateOfService)}`} pageViewStore={nikoFacilityOrderClinicalReviewPreviewViewStore} isInventoryStepAllowed={isInventoryStepAllowed}>
        <div className="content__header__actions card--tertiary__data__item">
          {isHistoryVisible && <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Facility Order History" data-tooltip-id="clinicalReviewTooltip" onClick={() => orderHistory()}><i className="u-icon u-icon--med-lrg u-icon--us-history"></i></a>}
          <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Facility Preview" data-tooltip-id="clinicalReviewTooltip" onClick={() => goToFacilityPreview()}><i className="u-icon u-icon--sml u-icon--preview--dark"></i></a>
          <a className="btn btn--base btn--light u-mar--right--tny" target='_blank' data-tooltip-content="Ordering Calendar" data-tooltip-id="clinicalReviewTooltip" onClick={() => goToFacilityCalendar()}><i className="u-icon u-icon--sml u-icon--schedules"></i></a>
        </div>
      </NikoFacilityOrderStatusBar>}
      <div className="u-flex--space-between">
        <div className="tabs__wrapper">
          <div className="tabs tabs--fullwidth">
            {tabItems.map(item =>
              <BaasicButton key={item.abrv}
                className={"tabs__item " + (item.abrv == selectedStatusAbrv ? 'active' : '')}
                label={item.name}
                onClick={() => item.abrv != selectedStatusAbrv ? setStatus(item.abrv) : {}}
              />
            )}
          </div>
        </div>
        <div className="u-flex--default u-mar--left--auto">
          {disabledByStatus && !(!usIntakeStatus && !clinicalReviewStatus) &&
            <BaasicButton className="btn btn--base btn--primary u-mar--right--sml" disabled={disabledBySendOrder || disabled} label="Start" onClick={() => startClinicalReview()} />
          }
          {selectedStatusAbrv !== "discharge" &&
            <div className="multiselect__group is-questions u-mar--right--sml">
              <MultiSelect
                data={questionsStore.originalItems}
                textField="name"
                dataItemKey="id"
                value={selectedQuestions.slice()}
                filterable={false}
                placeholder="Please select"
                onChange={(e) => filterByQuestion(e)}
                tags={
                  selectedQuestions.length > 0
                    ? [
                      {
                        text: selectedQuestions.length == 1 ? selectedQuestions[0].name : `Multiple`,
                        data: selectedQuestions.slice(),
                      },
                    ] : []
                }
              />
            </div>
          }
          <div className="multiselect__group is-category u-mar--right--sml">
            <MultiSelect
              data={itemCategoryStore.originalItems}
              textField="name"
              dataItemKey="id"
              value={itemCategories.slice()}
              filterable={false}
              placeholder="Please select"
              onChange={(e) => filterByCategory(e)}
              tags={
                itemCategories.length > 0
                  ? [
                    {
                      text: itemCategories.length == 1 ? itemCategories[0].name : `Multiple`,
                      data: itemCategories.slice(),
                    },
                  ] : []
              }
            />
          </div>
          <div className='u-mar--right--sml'>
            <DropDownButton
              fillMode={"solid"}
              themeColor={"primary"}
              text="Actions"
              onItemClick={(e) => handleActionDropDownItemsOnClick(e)}
              buttonClass="btn btn--base btn--sml btn--ghost"
              popupSettings={{
                popupClass: "is-clean",
                animate: false,
                anchorAlign: { horizontal: "right", vertical: "bottom" },
                popupAlign: { horizontal: "right", vertical: "top" }
              }}
            >
              <DropDownButtonItem text="New Patient" iconClass="u-icon u-icon--sml u-icon--add-lined u-mar--right--tny" />
              <DropDownButtonItem text="Overview Email" />
              <DropDownButtonItem text="Documentation Request" />
              <DropDownButtonItem text="Inventory Report" />
              {!disabledBySendOrder && <DropDownButtonItem text="Find and Replace" />}
              <DropDownButtonItem text="Create Niko SOs" disabled={creatingNikoSOs} />
              <DropDownButtonItem text="Create Niko Invoices" disabled={creatingNikoInvoices} />
            </DropDownButton>
          </div>
        </div>
      </div>
      {fetchingData ?
        <div>Loading...</div>
        :
        <React.Fragment>
          {!usIntakeStatus && !clinicalReviewStatus &&
            <div className="u-mar--bottom--sml">Clinical Review cannot be started prior to US Intake starting their flow.</div>
          }
          {selectedStatusAbrv === "in-progress" && clinicalReviewStatus && clinicalReviewStatus.completedOn &&
            <div className='u-mar--bottom--tny'>
              <div className="u-mar--bottom--sml">Clinical review has been completed on {moment(clinicalReviewStatus.completedOn).format("MM/DD/YYYY, hh:mm A")}</div>
            </div>
          }
          {selectedStatusAbrv === "discharge" && (usIntakeStatus && usIntakeStatus.completedOn) && !(clinicalReviewStatus && clinicalReviewStatus.completedOn) && isReviewed &&
            <div className="empty-state--facility-orders-discharges">
              <p className="empty-state--facility-orders-discharges--description">You have no orders in progress!</p>
              {(!isDocumentationRequestSent && hasMissingDocuments) ?
                <BaasicButton className="btn btn--base btn--primary" disabled={disabledBySendOrder} label="Document Request" icon="u-icon u-icon--med u-icon--mail-send--new--invert" onClick={() => documentationRequestCreate()} />
                :
                <BaasicButton className="btn btn--base btn--primary" disabled={disabledBySendOrder} label="Clinical Review is Complete" onClick={() => setClinicalReviewCompleted()} />
              }
            </div>
          }
          {(nikoPatientDetails && nikoPatientDetails.length > 0) ?
            nikoPatientDetails.map(nikoPatientDetail => {
              return (
                <NikoPatientTemplate
                  key={nikoPatientDetail.id}
                  nikoFacilityOrderClinicalReviewPreviewViewStore={nikoFacilityOrderClinicalReviewPreviewViewStore}
                  nikoPatientDetail={nikoPatientDetail}
                />
              );
            })
            :
            isEmpty ?
              (usIntakeStatus && usIntakeStatus.completedOn) ?
                (isReviewed &&
                  <div className="empty-state--facility-orders">
                    <div className="empty-state--facility-orders--table"></div>
                    <p className="empty-state--facility-orders--description">You have no orders in progress!</p>

                    {((!isDocumentationRequestSent && !hasMissingDocuments) ||
                      (isDocumentationRequestSent && hasMissingDocuments) ||
                      (isDocumentationRequestSent && !hasMissingDocuments)) && (
                        <BaasicButton
                          className="btn btn--base btn--primary"
                          label="Clinical Review is Complete"
                          disabled={disabledBySendOrder}
                          onClick={() => setClinicalReviewCompleted()}
                        />
                      )}

                    {(!isDocumentationRequestSent && hasMissingDocuments) && (
                      <BaasicButton
                        className="btn btn--base btn--primary"
                        label="Document Request"
                        icon="u-icon u-icon--med u-icon--mail-send--new--invert"
                        disabled={disabledBySendOrder}
                        onClick={() => documentationRequestCreate()}
                      />
                    )}
                  </div>
                )
                :
                isReviewed && (
                  <div className="u-mar--bottom--sml">
                    Clinical Review can't be completed before US Intake is completed.
                  </div>
                )
              :
              <React.Fragment></React.Fragment>
          }
        </React.Fragment>
      }
      <BaasicConfirmModal modalParams={statusConfirmModal} />
      <BaasicConfirmModal modalParams={documentationRequestConfirmModal} />
      <BaasicConfirmModal modalParams={invoiceSalesOrderLinkConfirmModal} />
      <BaasicDraggableModal modalParams={nikoPatientInsuranceQuestionModal} className="modal__content modal--med">
        <NikoPatientInsuranceQuestionModal />
      </BaasicDraggableModal>
      <BaasicDraggableModal modalParams={nikoPatientInsuranceInfoNoteModal} className="modal__content modal--med">
        <NikoPatientInsuranceInfoNoteModal />
      </BaasicDraggableModal>
      <BaasicModal modalParams={nikoPatientEligibilityStatusNoteModal} className="modal__content modal--med">
        <NikoPatientEligibilityStatusNoteModal />
      </BaasicModal>
      <BaasicModal modalParams={nikoTemplateCreateModal} className="modal__content modal--xxlrg">
        <NikoTemplateCreateModal />
      </BaasicModal>
      <BaasicDraggableModal modalParams={nikoTemplateMissingProductNoteModal} className="modal__content modal--med">
        <NikoTemplateMissingProductNoteModal />
      </BaasicDraggableModal>
      <BaasicDraggableModal modalParams={nikoTemplateInvoiceNoteModal} className="modal__content modal--med">
        <NikoTemplateInvoiceNoteModal />
      </BaasicDraggableModal>
      <BaasicDraggableModal modalParams={patientTemplateDoNotSupplyModal} className="modal__content modal--med">
        <NikoFacilityOrderConfirmationModal />
      </BaasicDraggableModal>
      <BaasicDraggableModal modalParams={patientTemplateDiscontinuedModal} className="modal__content modal--med">
        <NikoFacilityOrderConfirmationModal />
      </BaasicDraggableModal>
      <BaasicModal modalParams={nikoPatientStatusModal} className="modal__content modal--med">
        <NikoPatientStatusModal />
      </BaasicModal>
      <BaasicModal modalParams={patientTemplateDeleteModal} className="modal__content modal--med">
        <FacilityOrderTemplateNewFlowDeleteModal />
      </BaasicModal>
      <BaasicDraggableModal modalParams={nikoPatientTemplateItemCalculationModal} className="modal__content modal--lrg">
        <NikoPatientTemplateItemCalculationModal />
      </BaasicDraggableModal>
      <BaasicModal modalParams={nikoFacilityOrderReasonForChangeModal} className="modal__content modal--lrg">
        <NikoFacilityOrderReasonForChangeModal />
      </BaasicModal>
      <BaasicModal modalParams={nikoPatientTemplateItemNewFlowDeleteQuestionModal} className="modal__content modal--med">
        <FacilityOrderTemplateItemNewFlowDeleteQuestionModal />
      </BaasicModal>
      <BaasicConfirmModal modalParams={templateChangeConfirmModal} />
      <BaasicModal modalParams={patientTemplateClinicalStatusNoteModal} className="modal__content modal--med">
        <PatientTemplateClinicalStatusNoteModal />
      </BaasicModal>
      <BaasicModal modalParams={nikoTemplateMissingDocumentNoteModal} className="modal__content modal--med">
        <NikoTemplateMissingDocumentNoteModal />
      </BaasicModal>
      <BaasicModal modalParams={templatePNMissingInformationModal} className="modal__content modal--med">
        <FacilityOrderTemplatePNMissingInformationModal />
      </BaasicModal>
      <BaasicModal modalParams={nikoFacilityOrderFindAndReplaceModal} className="modal__content modal--xlrg">
        <NikoFacilityOrderUSIntakeFindAndReplaceModal />
      </BaasicModal>
      <BaasicModal modalParams={nikoFacilityOrderNewFlowExtraSuppliesAddModal} className="modal__content modal--xxlrg">
        <NikoFacilityOrderNewFlowExtraSuppliesAddModal />
      </BaasicModal>
      <BaasicDraggableModal modalParams={patientTemplateNoteModal} className="modal__content modal--med">
        <NikoFacilityOrderPatientTemplateNoteModal />
      </BaasicDraggableModal>
      <BaasicModal modalParams={nikoCreateNewPatientModal} className="modal__content modal--xxlrg">
        <NikoCreateNewPatientModal />
      </BaasicModal>
      <ScrollToTopButton />
    </PreviewLayout>
  )
}

NikoFacilityOrderClinicalReviewPreviewTemplate.propTypes = {
  nikoFacilityOrderClinicalReviewPreviewViewStore: PropTypes.object.isRequired
};

const TooltipContent = observer(({ initianValue, history, fieldName }) => {
  if (!history || history.fieldName !== fieldName) return null;
  const date = new Date(history.eventDate + "Z");
  const formattedDate = date.toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '');
  if (fieldName === 'ImportAction') {
    return (<div>
      <div>{history.action} by {history.userName}</div>
      <div style={{ fontSize: '11px', opacity: 0.75 }}>{formattedDate}</div>
    </div>);
  }
  return (<div>
    <div>Previous: {initianValue ? initianValue : 'blank'}</div>
    <div style={{ fontSize: '11px', opacity: 0.75 }}>{history ? history.userName + ', ' + formattedDate : '\u2014'}</div>
  </div>);
});

const InsuranceChangeMessage = observer(({ label, initialValue, currentValue, changeHistory }) => {
  var historyEntry = changeHistory || null;
  var formattedDate = '';
  if (historyEntry && historyEntry.eventDate) {
    var date = new Date(historyEntry.eventDate + "Z");
    formattedDate = date.toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '');
  }
  return (
    <div className="u-flex--default u-flex--gap--2 c-message--content">
      <p className="type--sml"><b>{label}</b></p>
      <label className="type--sml type--color--opaque"><b>{initialValue || "Empty"}</b></label>
      <p className="type--sml"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></p>
      <p className="type--sml"><b>{currentValue || "Empty"}</b></p>
      {historyEntry && historyEntry.userName && (
        <div className="card--info__wrap">
        <span className="card--info">{historyEntry.userName}, {formattedDate}</span>
        </div>
      )}
    </div>
  );
});

const NikoPatientTemplate = observer(({ nikoFacilityOrderClinicalReviewPreviewViewStore, nikoPatientDetail }) => {
  const {
    selectedStatusAbrv,
    disabledByStatus,
    disabledBySendOrder,
    disabled,
    statusStore,
    inProgressStatusId,
    openNikoPatientInsuranceQuestionModal,
    openNikoPatientInsuranceInfoNoteModal,
    openNikoHealthPatient,
    updateNikoPatientInsuranceInfoNote,
    openNikoPatientEligibilityStatusNoteModal,
    openNikoTemplateCreateModal,
    openNikoPatientStatusModal,
    openReasonForChangeModal,
    showPreviousFlag,
    getFieldHistory,
    fetchInsuranceChangeHistory,
    insuranceChangeHistoryMap,
    showInsuranceChangeHistory,
    noChangeStatusId,
    statuses
  } = nikoFacilityOrderClinicalReviewPreviewViewStore;

  const isAllDisabled = disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled;
  var ichVisible = showInsuranceChangeHistory === nikoPatientDetail.id;
  var ich = ichVisible ? (insuranceChangeHistoryMap[nikoPatientDetail.id] || {}) : {};

  return (
    <React.Fragment>
      <ReactTooltip positionStrategy="fixed" id={"nikoPatientTooltip" + nikoPatientDetail.id} place="bottom" />
      <ReactTooltip positionStrategy="fixed" id={"registerPatientTopTip" + nikoPatientDetail.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={nikoPatientDetail.initialNikoPatientDetail && nikoPatientDetail.initialNikoPatientDetail.Status} history={nikoPatientDetail.history} fieldName={"Status"} />} />
      <div className="card--tertiary u-mar--bottom--sml--alt">
        <div className={`card--tertiary__header is-niko ${selectedStatusAbrv === "discharge" ? "" : "card--tertiary__header--insurance"}`}>
          <div className="u-flex--default">
            <h4 className="card--tertiary__header__title">
              {nikoPatientDetail.nikoPatient.lastName && `${nikoPatientDetail.nikoPatient.lastName}`}
              {nikoPatientDetail.nikoPatient.lastName && nikoPatientDetail.nikoPatient.firstName && ', '}
              {nikoPatientDetail.nikoPatient.firstName && `${nikoPatientDetail.nikoPatient.firstName}`}
            </h4>
            <NikoPatientInformationBar nikoPatient={nikoPatientDetail.nikoPatient} disabled={isAllDisabled} showVisibilityOption={true} />
          </div>
          {
            nikoPatientDetail.isNew && selectedStatusAbrv === "discharge" &&
            <div className="status status--sml status--success">
              <p>New Patient</p>
            </div>
          }
          <div className="u-flex--default u-align--h--right">
            <BaasicButton
              className="btn btn--icon--sml-med btn--light is-plus u-mar--right--xsml"
              icon="u-icon u-icon--xmed u-icon--add-lined"
              label="Add Template"
              onlyIcon={true}
              onClick={() => { openNikoTemplateCreateModal(nikoPatientDetail) }}
              disabled={isAllDisabled}
            />
            {
              nikoPatientDetail.patientTemplates.some(x => !x.isInitialIntakeReviewed) ?
                <div className="segmented-control u-mar--left--xsml">
                  <Button key={statuses[0].id} className={nikoPatientDetail.hospitalClassName} onClick={() => openNikoPatientStatusModal(nikoPatientDetail, statuses[0].id)} disabled={isAllDisabled}>{statuses[0].id}
                    {nikoPatientDetail.status === "Hospital" && showPreviousFlag(nikoPatientDetail) && !nikoPatientDetail.isNew && <div className="previous-status-opacity-75" data-tooltip-id={"registerPatientTopTip" + nikoPatientDetail.id} onMouseEnter={async () => await getFieldHistory(nikoPatientDetail, 'Status', nikoPatientDetail.status)} data-tooltip-content="" ></div>}
                  </Button>
                  <Button key={statuses[1].id} className={nikoPatientDetail.dischargedClassName} onClick={() => openNikoPatientStatusModal(nikoPatientDetail, statuses[1].id)} disabled={isAllDisabled}>{statuses[1].id}
                    {nikoPatientDetail.status === "Discharged" && showPreviousFlag(nikoPatientDetail) && !nikoPatientDetail.isNew && <div className="previous-status-opacity-75" data-tooltip-id={"registerPatientTopTip" + nikoPatientDetail.id} onMouseEnter={async () => await getFieldHistory(nikoPatientDetail, 'Status', nikoPatientDetail.status)} data-tooltip-content="" ></div>}
                  </Button>
                  <Button key={statuses[2].id} className={nikoPatientDetail.expiredClassName} onClick={() => openNikoPatientStatusModal(nikoPatientDetail, statuses[2].id)} disabled={isAllDisabled}>{statuses[2].id}
                    {nikoPatientDetail.status === "Expired" && showPreviousFlag(nikoPatientDetail) && !nikoPatientDetail.isNew && <div className="previous-status-opacity-75" data-tooltip-id={"registerPatientTopTip" + nikoPatientDetail.id} onMouseEnter={async () => await getFieldHistory(nikoPatientDetail, 'Status', nikoPatientDetail.status)} data-tooltip-content="" ></div>}
                  </Button>
                  <Button key={statuses[3].id} className={nikoPatientDetail.activeClassName} onClick={() => nikoPatientDetail.status != statuses[3].id ? openNikoPatientStatusModal(nikoPatientDetail, statuses[3].id) : {}} disabled={isAllDisabled}>{statuses[3].id}
                    {nikoPatientDetail.status === "Active" && showPreviousFlag(nikoPatientDetail) && !nikoPatientDetail.isNew && <div className="previous-status-opacity-75" data-tooltip-id={"registerPatientTopTip" + nikoPatientDetail.id} onMouseEnter={async () => await getFieldHistory(nikoPatientDetail, 'Status', nikoPatientDetail.status)} data-tooltip-content="" ></div>}
                  </Button>
                </div>
                :
                <div className={`${showPreviousFlag(nikoPatientDetail) && !nikoPatientDetail.isNew ? "k-dropdown--status-indicator-opacity-50" : ""} w--200--px u-align--h--right u-mar--left--xsml`} >
                  <BaasicDropdown store={statusStore} value={nikoPatientDetail.status} onChange={(e) => { openNikoPatientStatusModal(nikoPatientDetail, e.value.id) }} disabled={isAllDisabled} />
                  <div className="k-dropdown--tooltip" data-tooltip-id={showPreviousFlag(nikoPatientDetail) && !nikoPatientDetail.isNew ? "registerPatientTopTip" + nikoPatientDetail.id : ""} onMouseEnter={async () => await getFieldHistory(nikoPatientDetail, 'Status', nikoPatientDetail.status)} data-tooltip-content="" ></div>
                </div>
            }
          </div>
        </div>
        <React.Fragment>
          {selectedStatusAbrv !== "discharge" &&
            <div className='niko__status__wrapper u-mar--right--status-low'>
              {nikoPatientDetail.isNew ?
                <div className={` ${isAllDisabled ? "is-disabled" : ""}`}>
                  <div className="niko__status yellow no-bg">
                    <div className="niko__status__holder">
                      <Button className="niko__status__btn" icon="u-icon u-icon--xsml u-icon--persons--yellow" disabled={isAllDisabled}>NEW PATIENT</Button>
                    </div>
                  </div>
                </div>
                :
                nikoPatientDetail.insuranceStatusId === inProgressStatusId ?
                  <div className="niko__status grey">
                    <div className={`niko__status__holder not-assigned`}>
                      <Button icon="u-icon u-icon--xxsml u-icon--info-fill u-mar--y--sml" className="niko__status__btn" > NOT ASSIGNED </Button>
                    </div>
                  </div>
                  :
                  <div className={`${isAllDisabled ? "is-disabled" : ""}`}>
                    <div className={`niko__status yellow ${nikoPatientDetail.insuranceStatusId === noChangeStatusId ? "success" : "warning"}`}>
                      <div className="niko__status__holder">
                        <Button className={`niko__status__btn ${nikoPatientDetail.insuranceStatusId === noChangeStatusId ? "success" : "warning"}`}> {nikoPatientDetail.insuranceStatusId === noChangeStatusId ? "NO CHANGES" : "CHANGES"} </Button>
                      </div>
                    </div>
                  </div>
              }
            </div>
          }
          <div className="card--tertiary__subheader btn--group__wrapper is-niko ">
            <div className="card--tertiary__flex">
              <div className="status--sqare__wrapper u-mar--left--xsml">
                <BaasicButton
                  className="btn btn--base-plus btn--light btn--uppercase  no-click"
                  label={nikoPatientDetail.eligibilityStatus ? nikoPatientDetail.eligibilityStatus.name : "Blank"}
                  disabled={isAllDisabled}
                />
                {nikoPatientDetail.eligibilityStatus && nikoPatientDetail.eligibilityStatus.name != "Eligible" &&
                  <React.Fragment>
                    <ReactTooltip positionStrategy="fixed" id={"patientTemplateEligibilityStatusNoteTooltip" + nikoPatientDetail.id} place="bottom" />
                    <Button className="btn btn--link u-mar--left--tny" icon="u-icon u-icon--med u-icon--us-note" onClick={() => openNikoPatientEligibilityStatusNoteModal(nikoPatientDetail)} disabled={isAllDisabled} data-tooltip-content="Eligibility Status Note" data-tooltip-id={"patientTemplateEligibilityStatusNoteTooltip" + nikoPatientDetail.id} />
                  </React.Fragment>
                }
              </div>
              <div className="card--tertiary__data">
                <div>
                  <div className="card--tertiary__data__item">
                    <div>Primary:</div>
                    <div className="type--color--primary type--wgt--semibold">{nikoPatientDetail.primaryActive.insurance.current && nikoPatientDetail.primaryActive.insurance.current.name}</div>
                    {nikoPatientDetail.primaryActive.policyNo.current && <div>{nikoPatientDetail.primaryActive.policyNo.current}</div>}
                  </div>
                  {nikoPatientDetail.primaryInactive.insurance.current &&
                    <div className="card--tertiary__data__item">
                      <div>Inactive:</div>
                      <div className="type--color--primary type--wgt--semibold">{nikoPatientDetail.primaryInactive.insurance.current.name}</div>
                      <div>{nikoPatientDetail.primaryInactive.policyNo.current && nikoPatientDetail.primaryInactive.policyNo.current}</div>
                    </div>
                  }
                </div>
                <div>
                  <div className="card--tertiary__data__item">
                    <div>Secondary:</div>
                    <div className="type--color--primary type--wgt--semibold">{nikoPatientDetail.secondaryActive.insurance.current && nikoPatientDetail.secondaryActive.insurance.current.name}</div>
                    {nikoPatientDetail.secondaryActive.policyNo.current && <div>{nikoPatientDetail.secondaryActive.policyNo.current}</div>}
                  </div>
                  {nikoPatientDetail.secondaryInactive.insurance.current &&
                    <div className="card--tertiary__data__item">
                      <div>Inactive:</div>
                      <div className="type--color--primary type--wgt--semibold">{nikoPatientDetail.secondaryInactive.insurance.current.name}</div>
                      <div>{nikoPatientDetail.secondaryInactive.policyNo.current && nikoPatientDetail.secondaryInactive.policyNo.current}</div>
                    </div>
                  }
                </div>
              </div>
              {
                nikoPatientDetail.insuranceQuestion &&
                <div className="u-flex u-flex--default u-flex--gap--2">
                  <div className="card--tertiary__header__divider"></div>
                  <Button className="btn btn--status--red u-mar--left--xsml" icon="u-icon u-icon--med-lrg u-icon--us-question-note--red" onClick={() => { openNikoPatientInsuranceQuestionModal(nikoPatientDetail) }} disabled={isAllDisabled} />
                </div>
              }
              <div className="u-flex u-flex--default u-align--h--right">
                <div className="btn--group">
                  <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-insurance-external-link" onClick={() => openNikoHealthPatient(nikoPatientDetail.nikoPatient.remoteId)} disabled={isAllDisabled} data-tooltip-content="Niko" data-tooltip-id={"nikoPatientTooltip" + nikoPatientDetail.id} />
                  {!nikoPatientDetail.insuranceQuestion &&
                    <React.Fragment>
                      <ReactTooltip positionStrategy="fixed" id={"nikoPatientInsuranceQuestionTooltip" + nikoPatientDetail.id} place="bottom" />
                      <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-question-note-sh" onClick={() => openNikoPatientInsuranceQuestionModal(nikoPatientDetail)} disabled={isAllDisabled} data-tooltip-content="Insurance Question" data-tooltip-id={"nikoPatientInsuranceQuestionTooltip" + nikoPatientDetail.id} />
                    </React.Fragment>
                  }
                  <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-note" onClick={() => openNikoPatientInsuranceInfoNoteModal(nikoPatientDetail)} disabled={isAllDisabled} data-tooltip-content="Insurance Info Note" data-tooltip-id={"nikoPatientTooltip" + nikoPatientDetail.id} />
                  <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-edit" onClick={() => { openReasonForChangeModal(nikoPatientDetail) }} disabled={isAllDisabled} data-tooltip-content="Edit Insurances" data-tooltip-id={"nikoPatientTooltip" + nikoPatientDetail.id} />
                  <div className="btn--group__divider"></div>
                </div>
                {nikoPatientDetail.patientTemplates.some(fot => fot.isPriorAuthNeeded) &&
                  <BaasicButton
                    type='button'
                    className="btn btn--base-plus btn--light is-grey no-click u-mar--right--tny"
                    label={`PAR ${nikoPatientDetail.patientTemplates.filter(fot => fot.isPriorAuthNeeded).length}/${nikoPatientDetail.patientTemplates.length}`}
                    disabled={isAllDisabled}
                  />
                }
              </div>
            </div>
            <div>
              {nikoPatientDetail.insuranceInfoNote &&
                <div className="c-message has-input c-message--note u-mar--top--sml">
                  <i className="u-icon u-icon--sml u-icon--add-note" />
                  <input
                    className="input input--sml input--message u-flex--grow--1 type--sml"
                    onClick={(e) => e.target.select()}
                    onChange={(e) => { updateNikoPatientInsuranceInfoNote(nikoPatientDetail, e.target.value) }}
                    onBlur={(e) => { updateNikoPatientInsuranceInfoNote(nikoPatientDetail, e.target.value, true) }}
                    value={nikoPatientDetail.tempInsuranceInfoNote}
                    disabled={isAllDisabled}
                  />
                </div>
              }
              {(nikoPatientDetail.note || nikoPatientDetail.hasHistory) &&
                <div className={`u-mar--top--lrg c-message has-dom-badge ${!nikoPatientDetail.isNew ? 'c-message--orange' : 'c-message--note--primary c-message--note--primary--tab'}`}>
                  {nikoPatientDetail.note &&
                    <React.Fragment>
                      <div className='c-message__badge'>
                        <i className='u-icon u-icon--size--badge u-icon--info-fill--neg'
                          onMouseEnter={() => { fetchInsuranceChangeHistory(nikoPatientDetail); nikoFacilityOrderClinicalReviewPreviewViewStore.setShowInsuranceChangeHistory(nikoPatientDetail.id); }}
                          onMouseLeave={() => { nikoFacilityOrderClinicalReviewPreviewViewStore.setShowInsuranceChangeHistory(null); }}>
                        </i>
                      </div>
                      <div className={`has-input ${nikoPatientDetail.isNew || !nikoPatientDetail.hasHistory ? '' : 'c-message--has-border'} u-flex--align-center is-center u-flex--default u-flex--gap--1 w--100 `} >
                        Note: <p style={{ fontWeight: "normal" }}>{nikoPatientDetail.note}</p>
                        {ich["Note"] && ich["Note"].userName && (() => {
                          var d = new Date(ich["Note"].eventDate + "Z");
                          var fd = d.toLocaleString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true }).replace(',', '');
                          return <div className="card--info__wrap"><span className="card--info">{ich["Note"].userName}, {fd}</span></div>;
                        })()}
                        {nikoPatientDetail.effectiveDate &&
                          <span className="u-align--h--right type--whitespace--nowrap">Effective Date: {toDate(nikoPatientDetail.effectiveDate)}</span>
                        }
                      </div>
                    </React.Fragment>
                  }
                  {!nikoPatientDetail.isNew &&
                    <React.Fragment>
                      <div className='c-message__badge'>
                        Changes
                        <i className='u-icon u-icon--size--badge u-icon--info-fill--neg'
                          onMouseEnter={() => { fetchInsuranceChangeHistory(nikoPatientDetail); nikoFacilityOrderClinicalReviewPreviewViewStore.setShowInsuranceChangeHistory(nikoPatientDetail.id); }}
                          onMouseLeave={() => { nikoFacilityOrderClinicalReviewPreviewViewStore.setShowInsuranceChangeHistory(null); }}>
                        </i>
                      </div>
                      {nikoPatientDetail.primaryActive.insuranceId.current != nikoPatientDetail.primaryActive.insuranceId.initial &&
                        <InsuranceChangeMessage label="Primary Active Changed" initialValue={nikoPatientDetail.primaryActive.insurance.initial ? nikoPatientDetail.primaryActive.insurance.initial.Name : null} currentValue={nikoPatientDetail.primaryActive.insurance.current ? nikoPatientDetail.primaryActive.insurance.current.name : null} changeHistory={ich["PrimaryActiveInsuranceId"]} />
                      }
                      {nikoPatientDetail.primaryActive.insuranceId.current == nikoPatientDetail.primaryActive.insuranceId.initial && nikoPatientDetail.primaryActive.policyNo.current != nikoPatientDetail.primaryActive.policyNo.initial &&
                        <InsuranceChangeMessage label="Primary Active Policy Number Changed" initialValue={nikoPatientDetail.primaryActive.policyNo.initial} currentValue={nikoPatientDetail.primaryActive.policyNo.current} changeHistory={ich["PrimaryActivePolicyNo"]} />
                      }
                      {nikoPatientDetail.primaryInactive.insuranceId.current && nikoPatientDetail.primaryInactive.insuranceId.current != nikoPatientDetail.primaryInactive.insuranceId.initial &&
                        <InsuranceChangeMessage label="Primary Inactive Changed" initialValue={nikoPatientDetail.primaryInactive.insurance.initial ? nikoPatientDetail.primaryInactive.insurance.initial.Name : null} currentValue={nikoPatientDetail.primaryInactive.insurance.current.name} changeHistory={ich["PrimaryInactiveInsuranceId"]} />
                      }
                      {nikoPatientDetail.primaryInactive.insuranceId.current && nikoPatientDetail.primaryInactive.insuranceId.current == nikoPatientDetail.primaryInactive.insuranceId.initial && nikoPatientDetail.primaryInactive.policyNo.current != nikoPatientDetail.primaryInactive.policyNo.initial &&
                        <InsuranceChangeMessage label="Primary Inactive Policy Number Changed" initialValue={nikoPatientDetail.primaryInactive.policyNo.initial} currentValue={nikoPatientDetail.primaryInactive.policyNo.current} changeHistory={ich["PrimaryInactivePolicyNo"]} />
                      }
                      {nikoPatientDetail.secondaryActive.insuranceId.current != nikoPatientDetail.secondaryActive.insuranceId.initial &&
                        <InsuranceChangeMessage label="Secondary Active Changed" initialValue={nikoPatientDetail.secondaryActive.insurance.initial ? nikoPatientDetail.secondaryActive.insurance.initial.Name : null} currentValue={nikoPatientDetail.secondaryActive.insurance.current ? nikoPatientDetail.secondaryActive.insurance.current.name : null} changeHistory={ich["SecondaryActiveInsuranceId"]} />
                      }
                      {nikoPatientDetail.secondaryActive.insuranceId.current == nikoPatientDetail.secondaryActive.insuranceId.initial && nikoPatientDetail.secondaryActive.policyNo.current != nikoPatientDetail.secondaryActive.policyNo.initial &&
                        <InsuranceChangeMessage label="Secondary Active Policy Number Changed" initialValue={nikoPatientDetail.secondaryActive.policyNo.initial} currentValue={nikoPatientDetail.secondaryActive.policyNo.current} changeHistory={ich["SecondaryActivePolicyNo"]} />
                      }
                      {nikoPatientDetail.secondaryInactive.insuranceId.current && nikoPatientDetail.secondaryInactive.insuranceId.current != nikoPatientDetail.secondaryInactive.insuranceId.initial &&
                        <InsuranceChangeMessage label="Secondary Inactive Changed" initialValue={nikoPatientDetail.secondaryInactive.insurance.initial ? nikoPatientDetail.secondaryInactive.insurance.initial.Name : null} currentValue={nikoPatientDetail.secondaryInactive.insurance.current.name} changeHistory={ich["SecondaryInactiveInsuranceId"]} />
                      }
                      {nikoPatientDetail.secondaryInactive.insuranceId.current && nikoPatientDetail.secondaryInactive.insuranceId.current == nikoPatientDetail.secondaryInactive.insuranceId.initial && nikoPatientDetail.secondaryInactive.policyNo.current != nikoPatientDetail.secondaryInactive.policyNo.initial &&
                        <InsuranceChangeMessage label="Secondary Inactive Policy Number Changed" initialValue={nikoPatientDetail.secondaryInactive.policyNo.initial} currentValue={nikoPatientDetail.secondaryInactive.policyNo.current} changeHistory={ich["SecondaryInactivePolicyNo"]} />
                      }
                      {nikoPatientDetail.eligibilityStatusId != (nikoPatientDetail.initialNikoPatientDetail ? nikoPatientDetail.initialNikoPatientDetail.EligibilityStatusId : null) &&
                        <InsuranceChangeMessage label="Insurance status changed" initialValue={nikoPatientDetail.initialNikoPatientDetail && nikoPatientDetail.initialNikoPatientDetail.EligibilityStatus ? nikoPatientDetail.initialNikoPatientDetail.EligibilityStatus.Name : null} currentValue={nikoPatientDetail.eligibilityStatusId != (nikoPatientDetail.initialNikoPatientDetail ? nikoPatientDetail.initialNikoPatientDetail.EligibilityStatusId : null) ? (nikoPatientDetail.eligibilityStatus ? nikoPatientDetail.eligibilityStatus.name : null) : null} changeHistory={ich["EligibilityStatusId"]} />
                      }
                      {nikoPatientDetail.patientTemplates.map(pt => {
                        return (!pt.isNew && (pt.isPriorAuthNeeded ? true : false) != (pt.initialPatientTemplate && pt.initialPatientTemplate.IsPriorAuthNeeded ? true : false) &&
                          <InsuranceChangeMessage key={pt.id + "-par"} label={`${pt.subCategory.name} template ${pt.portalId} PAR changed`} initialValue={pt.initialPatientTemplate && pt.initialPatientTemplate.IsPriorAuthNeeded ? "TRUE" : "FALSE"} currentValue={pt.isPriorAuthNeeded ? "TRUE" : "FALSE"} changeHistory={ich["PAR_" + pt.id]} />
                        );
                      })
                      }
                    </React.Fragment>
                  }
                </div>
              }
            </div>
          </div>
        </React.Fragment>

        <div className="card--tertiary__body is-niko">
          {
            nikoPatientDetail.patientTemplates.map(patientTemplate => {
              return (
                <PatientTemplateTable
                  key={patientTemplate.id}
                  nikoFacilityOrderClinicalReviewPreviewViewStore={nikoFacilityOrderClinicalReviewPreviewViewStore}
                  patientTemplate={patientTemplate}
                  nikoPatientDetail={nikoPatientDetail}
                />
              );
            })
          }
        </div>
      </div>
    </React.Fragment>
  );
});

NikoPatientTemplate.propTypes = {
  nikoFacilityOrderClinicalReviewPreviewViewStore: PropTypes.object.isRequired,
  nikoPatientDetail: PropTypes.object.isRequired
};

const PatientTemplateTable = observer(({ nikoFacilityOrderClinicalReviewPreviewViewStore, patientTemplate, nikoPatientDetail }) => {
  const {
    disabledByStatus,
    disabledBySendOrder,
    disabled,
    selectedStatusAbrv,
    inProgressStatusId,
    changeStatusId,
    noChangeStatusId,
    trachTubeSubCategoryId,
    dischargeStatusId,
    insertImportActionId,
    deleteImportActionId,
    updateImportActionId,
    ostomyItemCategoryId,
    changeItemsVisibility,
    addEmptyItem,
    saveItemOnProductSelect,
    editItem,
    updateItem,
    deletePatientTemplateItem,
    swapPatientTemplateItem,
    setAction,
    openNikoPatientTemplateItemCalculationModal,
    openPatientTemplateDoNotSupplyModal,
    openPatientTemplateDiscontinuedModal,
    openPatientTemplateDeleteModal,
    openPatientTemplateMissingProductNoteModal,
    openPatientTemplateInvoiceNoteModal,
    reviewPatientTemplates,
    isMasterPatient,
    facilityOrder,
    isEligible,
    updateSalesOrderNote,
    updateExpirationDate,
    updateMissingDocuments,
    updatePatientHeight,
    updatePatientWeight,
    generateStandardWrittenOrder,
    generateMedicalNecessityForm,
    generateMedicalNecessityFormAndStandardWrittenOrder,
    syncOrderingDoctors,
    isSyncInProgress,
    toggleThirdRow,
    openClinicalStatusNoteModal,
    openMissingDocumentNoteModal,
    getMissingDocsPreviousValue,
    getFieldHistory,
    openPatientTemplateNoteModal,
    importToNiko,
    confirmCreateNikoInvoice,
    importingToNikoTemplateIds,
    goToNikoHealthSalesOrder,
    goToNikoHealthInvoice,
    hasMeaningfulOrderChange,
    showItemQuantities,
    templateExpanded
  } = nikoFacilityOrderClinicalReviewPreviewViewStore;

  const isAllDisabled = disabledByStatus || disabledBySendOrder || disabled || nikoPatientDetail.disabled;
  const masterPatient = isMasterPatient(nikoPatientDetail);
  const eligible = isEligible(nikoPatientDetail);
  const missingDocsPrev = getMissingDocsPreviousValue(patientTemplate);
  const initDxCodes = patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.PatientTemplateDiagnosisCodes;
  const dxCodes = patientTemplate.patientTemplateDiagnosisCodes;
  const dropdownRef = React.createRef();

  const isExpanded = () => {
    return masterPatient || (patientTemplate.id === templateExpanded.id && templateExpanded.expanded === true);
  }

  const tableColSpan = () => {
    if ((isExpanded() || patientTemplate.isDifferentQty) && patientTemplate.patientTemplateItems.length > 0) {
      return 7;
    }
    return 6;
  }

  const productDropdownItemRender = (li, itemProps) => {
    const itemName = itemProps && itemProps.dataItem.description;
    const isPreferredIcon = itemProps && itemProps.dataItem.isPreferred && patientTemplate.itemCategoryId === ostomyItemCategoryId ?
      <i className="u-icon u-icon--xsml u-icon--star-outlined u-mar--right--tny"></i> : null;
    const isBackorderedIcon = itemProps && itemProps.dataItem.backordered ? <i className="u-icon u-icon--sml u-icon--backordered u-mar--left--tny"></i> : null;
    const nonBillableIcon = itemProps && !itemProps.dataItem.billableToMedicare ? <i className="u-icon u-icon--sml u-icon--non-billable u-mar--left--tny"></i> : null;
    const itemChildren = (
      <span style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <span style={{ flex: "1" }}> {li.props.children} </span>
        <span style={{ fontSize: "12px" }}> {isPreferredIcon} {itemName} {nonBillableIcon} {isBackorderedIcon}</span>
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  const tagRender = (tagData, li) => React.cloneElement(li, { children: <span key={uuid()} onClick={() => openMissingDocumentNoteModal(patientTemplate, tagData.data[0])}>{tagData.data[0].name}</span> });

  const dxCodeDropdownItemRender = (li, itemProps) => {
    const itemName = itemProps && itemProps.dataItem.name;
    const itemChildren = (
      <span style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <span style={{ flex: "1" }}> {li.props.children} </span>
        <span style={{ fontSize: "12px" }}>{itemName}</span>
      </span>
    );
    return React.cloneElement(li, li.props, itemChildren);
  };

  const handleItemClick = (e) => {
    e.currentTarget.select();
    showItemQuantities(patientTemplate, true);
  };

  return (
    <React.Fragment>
      <ReactTooltip positionStrategy="fixed" id={"patientTemplateTooltip" + patientTemplate.id} place="bottom" />
      {selectedStatusAbrv !== "discharge" &&
        <div className='niko__status__wrapper '>
          {patientTemplate.isNew ?
            <div className={`u-mar--right--status-top ${isAllDisabled ? "is-disabled" : ""}`}>
              <div className="niko__status no-bg yellow">
                <div className="niko__status__holder">
                  <Button className="niko__status__btn" icon="u-icon u-icon--xsml u-icon--box--yellow" onClick={() => { }} disabled={isAllDisabled}>NEW ORDER</Button>
                </div>
              </div>
            </div>
            :
            patientTemplate.intakeStatusId === inProgressStatusId ?
              <div className="niko__status grey u-mar--right--status-top">
                <div className={`niko__status__holder not-assigned`}>
                  <Button icon="u-icon u-icon--xxsml u-icon--info-fill u-mar--y--sml" className="niko__status__btn" onClick={() => { }}>NOT ASSIGNED</Button>
                </div>
              </div>
              :
              <div className={`u-mar--right--status-top ${isAllDisabled ? "is-disabled" : ""}`}>
                <div className={`niko__status ${patientTemplate.intakeStatusId === noChangeStatusId ? "success" : patientTemplate.intakeStatusId === changeStatusId ? "warning" : patientTemplate.intakeStatusId === dischargeStatusId ? "danger" : ""}`}>
                  <div className="niko__status__holder ">
                    <Button
                      className={`niko__status__btn ${patientTemplate.intakeStatusId === noChangeStatusId ? "success" : patientTemplate.intakeStatusId === changeStatusId ? "warning" : patientTemplate.intakeStatusId === dischargeStatusId ? "danger" : ""}`}
                      onClick={() => { }}
                      disabled={isAllDisabled}
                    >
                      {`${patientTemplate.intakeStatusId === noChangeStatusId ? "NO CHANGES" : patientTemplate.intakeStatusId === changeStatusId ? "CHANGES" : patientTemplate.intakeStatusId === dischargeStatusId ? "DISCONTINUED" : ""}`}
                    </Button>
                  </div>
                </div>
              </div>
          }
        </div>
      }
      <div className={`table--secondary__wrapper u-mar--bottom--med--condition is-niko ${trachTubeSubCategoryId == patientTemplate.subCategoryId && patientTemplate.isDiscontinued && nikoPatientDetail.status == "Active" ? 'is-add-new-disabled' : ''} ${selectedStatusAbrv === "discharge" ? "danger" : patientTemplate.isNew ? "new" : patientTemplate.intakeStatusId === noChangeStatusId ? "success" : patientTemplate.intakeStatusId === changeStatusId ? "warning-triangle" : patientTemplate.intakeStatusId === dischargeStatusId ? "danger" : ""} ${isAllDisabled || (patientTemplate.patientTemplateItems && patientTemplate.patientTemplateItems.some(x => !x.productId)) ? 'is-add-new-disabled' : ''}`}>
        <table className="table--secondary w--100">
          <colgroup>
            <col width={400} />
            <col width={150} />
            <col width={80} />
            {(isExpanded() || patientTemplate.isDifferentQty) && patientTemplate.patientTemplateItems.length > 0 && <col width={70} />}
            <col width={70} />
            <col />
            <col width={70} />
          </colgroup>
          <thead>
            <tr>
              <th colSpan={tableColSpan()} className="type--left">
                <div className="btn--group__wrapper u-flex--space-between">
                  <label>{patientTemplate.subCategory.name.toUpperCase()}</label>
                  {patientTemplate.isEligibleToSend != null && nikoPatientDetail.status == "Active" && !patientTemplate.isDiscontinued && !patientTemplate.isUserDns && !patientTemplate.isSystemDns && patientTemplate.patientTemplateItems.some(x => x.productId && x.actionId != deleteImportActionId && x.salesOrderQuantity > 0) &&
                    <div className="u-mar--left--xsml u-mar--bottom--tny" data-tooltip-content={!patientTemplate.isEligibleToSend && patientTemplate.nextSendDate ? `Next Send Date: ${toDate(patientTemplate.nextSendDate)}` : null} data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id}>
                      {patientTemplate.isEligibleToSend ? <i className="u-icon u-icon--med u-icon--calendar-yes--dark" /> : <i className="u-icon u-icon--med u-icon--calendar-x--dark" />}
                    </div>
                  }
                  {patientTemplate.isDiscontinued &&
                    <div>
                      <div className="u-mar--left--xsml btn--disc__wrapper">
                        Discontinued
                        <Button className="btn btn--disc" onClick={() => { openPatientTemplateDiscontinuedModal(patientTemplate) }} disabled={isAllDisabled}>
                          <i className="u-icon u-icon--xxsml u-icon--close--neg"></i>
                        </Button>
                      </div>
                    </div>
                  }
                  {patientTemplate.isUserDns &&
                    <div>
                      <div className="u-mar--left--xsml btn--disc__wrapper is-fr">
                        Do not supply - FR
                        <Button className="btn btn--disc" onClick={() => { openPatientTemplateDoNotSupplyModal(patientTemplate) }} disabled={isAllDisabled}>
                          <i className="u-icon u-icon--xxsml u-icon--close--neg"></i>
                        </Button>
                      </div>
                    </div>
                  }
                  {patientTemplate.isSystemDns &&
                    <div>
                      <div className="u-mar--left--xsml btn--disc__wrapper is-fr">
                        Do not supply
                      </div>
                    </div>
                  }
                  {patientTemplate.missingProductNote &&
                    <Button className="btn btn--status--red u-mar--left--xsml" icon="u-icon u-icon--med-lrg u-icon--missing-product" onClick={() => { openPatientTemplateMissingProductNoteModal(patientTemplate) }} disabled={isAllDisabled} />
                  }
                  {(patientTemplate.nikoOrderDisplayId || (patientTemplate.nikoInvoices && patientTemplate.nikoInvoices.length > 0)) &&
                    <div className="u-mar--left--sml type--color--secondary">
                      {patientTemplate.nikoOrderDisplayId &&
                        <button className={`btn btn--link btn--link--underline`} onClick={() => goToNikoHealthSalesOrder(patientTemplate.nikoOrderId)}>{patientTemplate.nikoOrderDisplayId}</button>
                      }
                      {patientTemplate.nikoInvoices && patientTemplate.nikoInvoices.map((invoice, index) =>
                        <button key={invoice.remoteId} className={`btn btn--link btn--link--underline ${(index > 0 || patientTemplate.nikoOrderDisplayId) ? 'u-mar--left--sml' : ''}`} onClick={() => goToNikoHealthInvoice(invoice.remoteId)}>{invoice.displayId}</button>
                      )}
                    </div>
                  }
                  <div className="card--tertiary__header__actions u-align--h--right">
                    <div className="btn--group">
                      {masterPatient && facilityOrder && facilityOrder.facility && facilityOrder.facility.sendAgoraPo === false &&
                        <React.Fragment>
                          <ReactTooltip positionStrategy="fixed" id={"patientTemplateInvoiceNoteTooltip" + patientTemplate.id} place="bottom" effect="solid" />
                          <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-invoice-note" onClick={() => { openPatientTemplateInvoiceNoteModal(patientTemplate) }} disabled={isAllDisabled} data-tooltip-content="Invoice Note" data-tooltip-id={"patientTemplateInvoiceNoteTooltip" + patientTemplate.id} />
                        </React.Fragment>
                      }
                      {patientTemplate.note && <Button className="btn no-hover" icon={"u-icon u-icon--med-lrg u-icon--danger-triangle--primary"} onClick={() => { openPatientTemplateNoteModal(patientTemplate) }} disabled={isAllDisabled} data-tooltip-content="View Note" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />}
                      {!patientTemplate.missingProductNote &&
                        <React.Fragment>
                          <ReactTooltip positionStrategy="fixed" id={"patientTemplateMissingProductNoteTooltip" + patientTemplate.id} place="bottom" />
                          <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-question-note" onClick={() => { openPatientTemplateMissingProductNoteModal(patientTemplate) }} disabled={isAllDisabled} data-tooltip-content="Missing Product Note" data-tooltip-id={"patientTemplateMissingProductNoteTooltip" + patientTemplate.id} />
                        </React.Fragment>
                      }
                      {!patientTemplate.isUserDns &&
                        <div className="btn--group status--sqare__wrapper">
                          <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--do-not-supply" onClick={() => { openPatientTemplateDoNotSupplyModal(patientTemplate) }} disabled={isAllDisabled} data-tooltip-content="Mark As Do Not Supply" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />
                        </div>
                      }
                      {!patientTemplate.isNew && !patientTemplate.isDiscontinued && <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--danger--primary" onClick={() => openPatientTemplateDiscontinuedModal(patientTemplate)} disabled={isAllDisabled} data-tooltip-content="Discontinued" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />}
                      {patientTemplate.isNew && <Button className="btn no-hover" icon="u-icon u-icon--delete--brand u-icon--med-lrg" onClick={() => openPatientTemplateDeleteModal(nikoPatientDetail, patientTemplate)} disabled={isAllDisabled} data-tooltip-content="Delete Template" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />}
                      {selectedStatusAbrv === "reviewed-clinical" && !patientTemplate.isUserDns && !patientTemplate.isSystemDns && patientTemplate.isEligibleToSend !== false && patientTemplate.patientTemplateItems.some(item => item.actionId !== deleteImportActionId && item.salesOrderQuantity > 0) && <Button className="btn no-hover" icon="u-icon u-icon--sml u-icon--upload" onClick={() => { importToNiko(patientTemplate.id, patientTemplate.nikoPatientDetailId) }} disabled={isAllDisabled || importingToNikoTemplateIds.includes(patientTemplate.id)} data-tooltip-content="Create Sales Order" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />}
                      {selectedStatusAbrv === "reviewed-clinical" && !patientTemplate.isUserDns && !patientTemplate.isSystemDns && patientTemplate.isEligibleToSend !== false && patientTemplate.patientTemplateItems.some(item => item.actionId !== deleteImportActionId && item.salesOrderQuantity > 0) && <Button className="btn no-hover" icon="u-icon u-icon--sml u-icon--upload" onClick={() => { confirmCreateNikoInvoice(patientTemplate, patientTemplate.nikoPatientDetailId) }} disabled={isAllDisabled || importingToNikoTemplateIds.includes(patientTemplate.id)} data-tooltip-content="Create Invoice" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />}
                      <div className="btn--group__divider"></div>
                    </div>
                    {eligible && patientTemplate.clinicalStatus && patientTemplate.clinicalStatus.name != "Covered" && patientTemplate.clinicalStatus.name != "Prior Auth Obtained" && patientTemplate.clinicalStatus.name != "Does Not Meet Insurance Criteria" &&
                      <Button className="btn btn--link" icon="u-icon u-icon--med u-icon--us-note" onClick={() => openClinicalStatusNoteModal(patientTemplate)} disabled={isAllDisabled} data-tooltip-content="Clinical Status Note" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id} />
                    }
                    {eligible && patientTemplate.clinicalStatusStore &&
                      <div className="is-blue" style={{ position: 'relative' }}>
                        <ReactTooltip positionStrategy="fixed" id={"registerTipClinicalStatusId" + patientTemplate.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ClinicalStatus && patientTemplate.initialPatientTemplate.ClinicalStatus.Name} history={patientTemplate.history} fieldName={"ClinicalStatusId"} />} />
                        {!patientTemplate.isNew && !nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ClinicalStatusId != patientTemplate.clinicalStatusId &&
                          <i className="input--change--text opacity-50" data-tooltip-id={"registerTipClinicalStatusId" + patientTemplate.id} onMouseEnter={async () => await getFieldHistory(patientTemplate, 'ClinicalStatusId', patientTemplate.clinicalStatusId)} data-tooltip-content="" ></i>}
                        <BaasicDropdown className="k-dropdown--primary k-dropdown--nowrap" store={patientTemplate.clinicalStatusStore} value={patientTemplate.clinicalStatus} disabled={isAllDisabled} />
                      </div>
                    }
                    {selectedStatusAbrv !== "discharge" &&
                      <React.Fragment>
                        {patientTemplate.isClinicalReviewed ?
                          <div className="status--sqare__wrapper" data-tooltip-content="Unreview" data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id}>
                            <Button className="btn btn--icon btn--icon--sml-med btn--primary" icon="u-icon u-icon--med u-icon--unreview" onClick={() => { reviewPatientTemplates(nikoPatientDetail, patientTemplate.id, false) }} disabled={isAllDisabled || !eligible} />
                          </div>
                          :
                          <div className="status--sqare__wrapper" data-tooltip-content={(eligible && !patientTemplate.clinicalStatusId) ? "Clinical Status must be selected" : "Review"} data-tooltip-id={"patientTemplateTooltip" + patientTemplate.id}>
                            <Button className="btn btn--icon btn--icon--sml-med btn--primary" icon="u-icon u-icon--med u-icon--check-list" onClick={() => { reviewPatientTemplates(nikoPatientDetail, patientTemplate.id, true) }} disabled={isAllDisabled || (eligible && !patientTemplate.clinicalStatusId)} />
                          </div>
                        }
                      </React.Fragment>
                    }
                  </div>
                </div>
                <div className="modal__body u-mar--top--sml is-blue">
                  {patientTemplate.showIncludeInDrNotification && selectedStatusAbrv === "in-progress" && hasMeaningfulOrderChange(patientTemplate) &&
                    <div className="row">
                      <div className="form__group col col-lrg-12">
                        <div className="message message--sml-med message--note">
                          <div className="u-flex--default w--100">
                            <i className="u-icon u-icon--med u-icon--warning-circle--peach u-mar--right--sml"></i>
                            <div className="u-mar--right--tny u-flex--grow--1 u-flex--default" style={{ fontSize: '13px' }}>A change to this order was made while documents were still missing. If documentation is still needed for the previous date(s), add the "Previous DOS" missing doc tags and customize wording to clarify what they apply to.</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div className="row">
                    <div className="form__group col col-lrg-7">
                      <div className="form__group__label">Sales Order Note</div>
                      <div className="input__wrapper">
                        <ReactTooltip positionStrategy="fixed" id={"registerTipSalesOrderNote" + patientTemplate.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.SalesOrderNote} history={patientTemplate.history} fieldName={"SalesOrderNote"} />} />
                        {!patientTemplate.isNew && !nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.SalesOrderNote != patientTemplate.tempSalesOrderNote &&
                          <i className="input--change--text opacity-50" data-tooltip-id={"registerTipSalesOrderNote" + patientTemplate.id} onMouseEnter={async () => await getFieldHistory(patientTemplate, 'SalesOrderNote', patientTemplate.salesOrderNote)} data-tooltip-content="" ></i>}
                        <input
                          className="input input--base input--text"
                          value={patientTemplate.tempSalesOrderNote || ''}
                          onChange={(e) => { patientTemplate.tempSalesOrderNote = e.target.value; }}
                          onBlur={() => { updateSalesOrderNote(patientTemplate, nikoPatientDetail); }}
                          disabled={isAllDisabled}
                        />
                      </div>
                    </div>
                    <div className="form__group col col-lrg-5">
                      <div className="form__group__label">Expiration Date</div>
                      <div className="input__wrapper">
                        <ReactTooltip positionStrategy="fixed" id={"registerTipExpirationDate" + patientTemplate.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ExpirationDate} history={patientTemplate.history} fieldName={"ExpirationDate"} />} />
                        {!patientTemplate.isNew && !nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.ExpirationDate != patientTemplate.tempExpirationDate &&
                          <i className="input--change--text opacity-50" data-tooltip-id={"registerTipExpirationDate" + patientTemplate.id} onMouseEnter={async () => await getFieldHistory(patientTemplate, 'ExpirationDate', patientTemplate.expirationDate)} data-tooltip-content="" ></i>}
                        <input
                          className="input input--base input--text"
                          value={patientTemplate.tempExpirationDate || ''}
                          onChange={(e) => { patientTemplate.tempExpirationDate = e.target.value; }}
                          onBlur={() => { updateExpirationDate(patientTemplate, nikoPatientDetail); }}
                          disabled={isAllDisabled}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row u-flex--align--end">
                    <div className="form__group col col-lrg-10">
                      <div className="form__group__label">Missing Docs</div>
                      {patientTemplate.missingDocumentStore &&
                        <div style={{ position: 'relative' }}>
                          <ReactTooltip positionStrategy="fixed" id={"registerTipMissingDocs" + patientTemplate.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={missingDocsPrev != null ? missingDocsPrev : undefined} history={patientTemplate.history} fieldName={"PatientTemplateMissingDocuments"} />} />
                          {!patientTemplate.isNew && !nikoPatientDetail.isNew && missingDocsPrev != null &&
                            <i className="input--change--text opacity-50" data-tooltip-id={"registerTipMissingDocs" + patientTemplate.id} onMouseEnter={async () => await getFieldHistory(patientTemplate, 'PatientTemplateMissingDocuments', patientTemplate.patientTemplateMissingDocuments && patientTemplate.patientTemplateMissingDocuments.map(x => x.missingDocumentId).join(','))} data-tooltip-content="" ></i>}
                          <BaasicDropdown
                            store={patientTemplate.missingDocumentStore}
                            value={patientTemplate.mappedMissingDocuments ? patientTemplate.mappedMissingDocuments.slice() : []}
                            multi={true}
                            tagRender={tagRender}
                            autoClose={true}
                            disabled={isAllDisabled}
                            onChange={(e) => { updateMissingDocuments(patientTemplate, nikoPatientDetail, e.target.value); }}
                          />
                        </div>
                      }
                    </div>
                    <div className="form__group col col-lrg-2">
                      <div className="form__group__label">Generate Documents:</div>
                      <div className='u-flex--default btn--grouped'>
                        <BaasicButton
                          onlyIcon={true}
                          className='btn btn--sml btn--light u-mar--right--tny'
                          label='SWO & PN'
                          icon="u-icon u-icon--sml u-icon--download--brand"
                          onClick={() => generateMedicalNecessityFormAndStandardWrittenOrder(patientTemplate, nikoPatientDetail)}
                        />
                        <BaasicButton
                          className='btn btn--sml btn--light u-mar--right--tny'
                          label='SWO'
                          onClick={() => generateStandardWrittenOrder(patientTemplate, nikoPatientDetail)}
                        />
                        <BaasicButton
                          className='btn btn--sml btn--light u-mar--right--tny'
                          label='PN'
                          onClick={() => generateMedicalNecessityForm(patientTemplate, nikoPatientDetail)}
                        />
                        <PatientTemplateCustomOrderingDoctorAdd patientTemplate={patientTemplate} />
                      </div>
                    </div>
                  </div>
                  <a className="u-anchor--sml--underline u-mar--bottom--med" onClick={() => toggleThirdRow(patientTemplate, nikoPatientDetail)}> {patientTemplate.showThirdRow ? "Show less" : "Show more"}</a>
                  {patientTemplate.showThirdRow &&
                    <div className="row">
                      <div className="col col-lrg-4">
                        <div className="row">
                          <div className="form__group col col-lrg-2">
                            <div className="form__group__label">Height (in.)</div>
                            <div className="input__wrapper">
                              <ReactTooltip positionStrategy="fixed" id={"registerTipHeight" + nikoPatientDetail.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={nikoPatientDetail.initialNikoPatientDetail && nikoPatientDetail.initialNikoPatientDetail.Height} history={nikoPatientDetail.history} fieldName={"Height"} />} />
                              {!patientTemplate.isNew && !nikoPatientDetail.isNew && nikoPatientDetail.initialNikoPatientDetail && nikoPatientDetail.initialNikoPatientDetail.Height != nikoPatientDetail.height &&
                                <i className="input--change--text opacity-50" data-tooltip-id={"registerTipHeight" + nikoPatientDetail.id} onMouseEnter={async () => await getFieldHistory(nikoPatientDetail, 'Height', nikoPatientDetail.height)} data-tooltip-content="" ></i>}
                              <input
                                className="input input--base input--text"
                                type="number"
                                value={nikoPatientDetail.height != null ? nikoPatientDetail.height : ''}
                                onClick={(e) => e.target.select()}
                                onChange={(e) => { nikoPatientDetail.height = e.target.value ? parseFloat(e.target.value) : null; }}
                                onBlur={() => { updatePatientHeight(nikoPatientDetail); }}
                                disabled={isAllDisabled}
                              />
                            </div>
                          </div>
                          <div className="form__group col col-lrg-2">
                            <div className="form__group__label">Weight (lbs.)</div>
                            <div className="input__wrapper">
                              <ReactTooltip positionStrategy="fixed" id={"registerTipWeight" + nikoPatientDetail.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={nikoPatientDetail.initialNikoPatientDetail && nikoPatientDetail.initialNikoPatientDetail.Weight} history={nikoPatientDetail.history} fieldName={"Weight"} />} />
                              {!patientTemplate.isNew && !nikoPatientDetail.isNew && nikoPatientDetail.initialNikoPatientDetail && nikoPatientDetail.initialNikoPatientDetail.Weight != nikoPatientDetail.weight &&
                                <i className="input--change--text opacity-50" data-tooltip-id={"registerTipWeight" + nikoPatientDetail.id} onMouseEnter={async () => await getFieldHistory(nikoPatientDetail, 'Weight', nikoPatientDetail.weight)} data-tooltip-content="" ></i>}
                              <input
                                className="input input--base input--text"
                                type="number"
                                value={nikoPatientDetail.weight != null ? nikoPatientDetail.weight : ''}
                                onClick={(e) => e.target.select()}
                                onChange={(e) => { nikoPatientDetail.weight = e.target.value ? parseFloat(e.target.value) : null; }}
                                onBlur={() => { updatePatientWeight(nikoPatientDetail); }}
                                disabled={isAllDisabled}
                              />
                            </div>
                          </div>
                          <div className="form__group col col-lrg-8">
                            <div className="form__group__label">
                              Ordering Doctor
                              <i title='Sync Ordering Doctors' className={`u-icon u-icon--sml u-icon--synchronize--${isSyncInProgress ? "grey" : "primary"} u-mar--left--tny`} onClick={() => syncOrderingDoctors()}></i>
                            </div>
                            {patientTemplate.doctorStore &&
                              <div style={{ position: 'relative' }}>
                                <ReactTooltip positionStrategy="fixed" id={"registerTipOrderingDoctorId" + patientTemplate.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.OrderingDoctor && patientTemplate.initialPatientTemplate.OrderingDoctor.Name + " - " + patientTemplate.initialPatientTemplate.OrderingDoctor.Npi} history={patientTemplate.history} fieldName={"OrderingDoctorId"} />} />
                                {!patientTemplate.isNew && !nikoPatientDetail.isNew && patientTemplate.initialPatientTemplate && patientTemplate.initialPatientTemplate.OrderingDoctorId != patientTemplate.orderingDoctorId &&
                                  <i className="input--change--text opacity-50" data-tooltip-id={"registerTipOrderingDoctorId" + patientTemplate.id} onMouseEnter={async () => await getFieldHistory(patientTemplate, 'OrderingDoctorId', patientTemplate.orderingDoctorId)} data-tooltip-content="" ></i>}
                                <BaasicDropdown store={patientTemplate.doctorStore} value={patientTemplate.orderingDoctor ? { ...patientTemplate.orderingDoctor, orderingDoctor: patientTemplate.orderingDoctor.name + " - " + patientTemplate.orderingDoctor.npi + (patientTemplate.orderingDoctor.primaryAddressState ? " - " + patientTemplate.orderingDoctor.primaryAddressState : "") } : null} allowEmpty={true} disabled={isAllDisabled} itemRender={orderingDoctorItemRender} valueRender={orderingDoctorValueRender} onChange={async (e) => { if (e.target.value && !e.target.value.pecosEnrollment) return; patientTemplate.orderingDoctorId = e.target.value ? e.target.value.id : null; patientTemplate.orderingDoctor = e.target.value; await nikoFacilityOrderClinicalReviewPreviewViewStore.updateClinicalField(patientTemplate, nikoPatientDetail); }} />

                                {patientTemplate.orderingDoctor && !isAllDisabled &&
                                  <button className='k-clear-button' onClick={async () => { patientTemplate.orderingDoctorId = null; patientTemplate.orderingDoctor = null; patientTemplate.doctorStore.setValue(null); await nikoFacilityOrderClinicalReviewPreviewViewStore.updateClinicalField(patientTemplate, nikoPatientDetail); }}>
                                    <span className="u-icon u-icon--xsml u-icon--close--primary"></span>
                                  </button>
                                }
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                      {[1, 2, 3, 4, 5, 6, 7, 8].map(n => {
                        const store = patientTemplate[`dxCode${n}Store`];
                        const initDxCode = initDxCodes && initDxCodes.find(x => x.Order === n);
                        const dxCode = dxCodes && dxCodes.find(x => x.order === n);
                        return store && (
                          <div key={n} className="form__group col col-lrg-1">
                            <div className="form__group__label">DX Code {n}</div>
                            <div style={{ position: 'relative' }}>
                              <ReactTooltip positionStrategy="fixed" id={"registerTipDxCode" + n + patientTemplate.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={initDxCode && initDxCode.DiagnosisCode && initDxCode.DiagnosisCode.Code} history={patientTemplate.history} fieldName={"DxCode" + n} />} />
                              {!patientTemplate.isNew && !nikoPatientDetail.isNew && (initDxCode ? initDxCode.DiagnosisCodeId : '') != (dxCode ? dxCode.diagnosisCodeId : '') &&
                                <i className="input--change--text opacity-50" data-tooltip-id={"registerTipDxCode" + n + patientTemplate.id} onMouseEnter={async () => await getFieldHistory(patientTemplate, 'DxCode' + n, store.value && store.value.id)} data-tooltip-content="" ></i>}
                              <BaasicDropdown store={store} value={store.value} allowEmpty={true} itemRender={dxCodeDropdownItemRender} disabled={isAllDisabled} onChange={async (e) => { store.setValue(e.target.value); await nikoFacilityOrderClinicalReviewPreviewViewStore.updateClinicalField(patientTemplate, nikoPatientDetail); }} />
                              {store.value && !isAllDisabled &&
                                <button className='k-clear-button' onClick={async () => { store.setValue(null); await nikoFacilityOrderClinicalReviewPreviewViewStore.updateClinicalField(patientTemplate, nikoPatientDetail); }}>
                                  <span className="u-icon u-icon--xsml u-icon--close--primary"></span>
                                </button>
                              }
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  }
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={3} className="table--secondary__last card--tertiary__body u-cursor--pointer no-right" onClick={() => { changeItemsVisibility(patientTemplate) }}>
                <div className="u-flex u-flex--default">
                  <span className="type--tiny type--color--opaque"> {patientTemplate.itemsVisible ? "Hide Items" : "View Items"}</span>
                  <i className={"u-icon u-icon--xsml " + (patientTemplate.itemsVisible ? "u-icon--arrow-up" : "u-icon--arrow-down") + " u-mar--left--sml"} />
                </div>
              </td>
              <td colSpan={1} className="table--secondary--special table__label--special u-cursor--pointer" onClick={() => { changeItemsVisibility(patientTemplate) }}>
                {(isExpanded() || patientTemplate.isDifferentQty) && patientTemplate.patientTemplateItems.length > 0 &&
                  <div>
                    {patientTemplate.itemsVisible && "TEMP QTY"}
                  </div>
                }
              </td>
              {(isExpanded() || patientTemplate.isDifferentQty) && patientTemplate.patientTemplateItems.length > 0 &&
                <td colSpan={1} className="table--secondary--special table__label--special u-cursor--pointer" onClick={() => { changeItemsVisibility(patientTemplate) }}>
                  {patientTemplate.itemsVisible && "SO QTY"}
                </td>
              }
              <td colSpan={2} className="table--secondary__last card--tertiary__body u-cursor--pointer" onClick={() => { changeItemsVisibility(patientTemplate) }}></td>
            </tr>
            {patientTemplate.itemsVisible && patientTemplate.patientTemplateItems.map((item) => {
              const isFormula = item.product && (item.product.itemTypeId || (item.product.procedureCode_ && item.product.procedureCode_.abrv === "B4155"));
              if (!item.product && item.toggle) {
                setTimeout(() => {
                  if (dropdownRef.current) {
                    // v14 dropped the inner .k-dropdown-wrap — the DropDownList root element is the clickable toggle
                    const toggle = dropdownRef.current.element;
                    if (toggle) {
                      item.toggle = false;
                      toggle.click();
                    }
                  }
                }, 0);
              }
              return (
                <tr key={item.id} className={`${(!patientTemplate.isNew && item.actionId === insertImportActionId && !nikoPatientDetail.isNew) ? "new-row" : (item.actionId === deleteImportActionId ? "deleted-row" : "")} ${item.product ? "" : "is-focused"}`}>
                  <td className="table-col-input is-flex">
                    <ReactTooltip positionStrategy="fixed" id={"registerTipImportAction" + item.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={null} history={item.history} fieldName={"ImportAction"} />} />
                    <ItemActionTriangle item={item} insertActionId={insertImportActionId} deleteActionId={deleteImportActionId} tooltipId={"registerTipImportAction" + item.id} onMouseEnter={async () => await getFieldHistory(item, 'ImportAction', null)} />
                    {item.product ?
                      <React.Fragment>{item.product.description} <span className="table__icons-wrapper"> {!item.product.billableToMedicare && <i className="u-icon u-icon--sml u-icon--non-billable"></i>} {(item.isBackordered != null ? item.isBackordered : item.product.backordered) && <i className="u-icon u-icon--med-lrg u-icon--backordered"></i>}</span></React.Fragment>
                      :
                      <BaasicDropdown
                        placeholder="Select item name..."
                        store={patientTemplate.productStore}
                        value={item.product}
                        className="input--table"
                        itemRender={productDropdownItemRender}
                        onChange={(e) => { saveItemOnProductSelect(patientTemplate, item, e.target.value) }}
                        disabled={isAllDisabled}
                        customRef={dropdownRef}
                        />
                    }
                  </td>
                  <td>
                    {item.product && item.product.itemId}
                  </td>
                  <td>
                    {item.procedureCode}
                  </td>
                  <td className="table-col-input text-align-left has-input" id={"templateQuantity-" + patientTemplate.id}>
                    <ReactTooltip positionStrategy="fixed" id={"registerTipQuantity" + item.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={item.initialPatientTemplateItem && item.initialPatientTemplateItem.Quantity} history={item.history} fieldName={"Quantity"} />} />
                    {!patientTemplate.isNew && !nikoPatientDetail.isNew && item.initialPatientTemplateItem && item.initialPatientTemplateItem.Quantity != item.quantity && item.actionId !== insertImportActionId && item.isQuantityConfirmed !== false &&
                      <div className="table-col-input__notif opacity-50" data-tooltip-id={"registerTipQuantity" + item.id} onMouseEnter={async () => await getFieldHistory(item, 'Quantity', item.quantity)} data-tooltip-content="" ></div>}
                    {item.product &&
                      <input
                        className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                        onClick={(e) => handleItemClick(e)}
                        onKeyDown={handleKeyDown}
                        onPaste={handlePaste}
                        onChange={(e) => { editItem(item, 'quantity', parseInt(e.target.value)) }}
                        onBlur={() => { updateItem(item, patientTemplate) }}
                        value={item.quantity || item.quantity === 0 ? item.quantity : ''}
                        type="number"
                        min="0"
                        disabled={isAllDisabled || masterPatient}
                      />
                    }
                    {(item.sendSeparatelyQuantity | 0) > 0 && <React.Fragment><ReactTooltip positionStrategy="fixed" id={"registerTipSS" + item.id} place="top" /><i className="u-icon u-icon--ss u-icon--sml table__icon--ss" data-tooltip-id={"registerTipSS" + item.id} data-tooltip-content={item.sendSeparatelyQuantity} /></React.Fragment>}
                  </td>
                  {(isExpanded() || patientTemplate.isDifferentQty) &&
                    <td className="table-col-input text-align-left has-input" id={"orderQuantity-" + patientTemplate.id}>
                      <ReactTooltip positionStrategy="fixed" id={"registerTipSalesOrderQuantity" + item.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={item.initialPatientTemplateItem && item.initialPatientTemplateItem.SalesOrderQuantity} history={item.history} fieldName={"SalesOrderQuantity"} />} />
                      {!patientTemplate.isNew && !nikoPatientDetail.isNew && item.initialPatientTemplateItem && item.initialPatientTemplateItem.SalesOrderQuantity != item.salesOrderQuantity && item.actionId !== insertImportActionId && item.isSalesOrderQuantityConfirmed !== false &&
                        <div className="table-col-input__notif opacity-50" data-tooltip-id={"registerTipSalesOrderQuantity" + item.id} onMouseEnter={async () => await getFieldHistory(item, 'SalesOrderQuantity', item.salesOrderQuantity)} data-tooltip-content="" ></div>}
                      {item.product &&
                        <input
                          className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                          onClick={(e) => handleItemClick(e)}
                          onKeyDown={handleKeyDown}
                          onPaste={handlePaste}
                          onChange={(e) => { editItem(item, 'salesOrderQuantity', parseInt(e.target.value)) }}
                          onBlur={() => { updateItem(item, patientTemplate) }}
                          value={item.salesOrderQuantity}
                          type="number"
                          min="0"
                          disabled={isAllDisabled}
                        />
                      }
                    </td>}
                  <td className="table-col-input">
                    <ReactTooltip positionStrategy="fixed" id={"registerTipNote" + item.id} place="top" delayShow={650} render={() => <TooltipContent initianValue={item.initialPatientTemplateItem && item.initialPatientTemplateItem.Note} history={item.history} fieldName={"Note"} />} />
                    {!patientTemplate.isNew && !nikoPatientDetail.isNew && item.initialPatientTemplateItem && item.initialPatientTemplateItem.Note != item.note && item.actionId !== insertImportActionId && item.isNoteConfirmed !== false &&
                      <div className="table-col-input__notif opacity-50" data-tooltip-id={"registerTipNote" + item.id} onMouseEnter={async () => await getFieldHistory(item, 'Note', item.note)} data-tooltip-content="" ></div>}
                    {isFormula && !masterPatient ?
                      <input
                        className="input--table input--inherit-color no-arrows input--text-align--left w--100 u-mar--left--tny"
                        onClick={() => openNikoPatientTemplateItemCalculationModal(item, patientTemplate)}
                        value={item.note}
                        readOnly={true}
                        disabled={isAllDisabled}
                      />
                      :
                      <input
                        className="input--table input--inherit-color no-arrows input--text-align--left w--100 u-mar--left--tny"
                        onClick={(e) => e.target.select()}
                        onChange={(e) => { editItem(item, 'note', e.target.value) }}
                        onBlur={() => { updateItem(item, patientTemplate) }}
                        value={item.note}
                        disabled={isAllDisabled || !item.product}
                        readOnly={false}
                      />
                    }
                  </td>
                  <td className="type--center is-hidden">
                    <div className="table__icons">
                      {item.actionId !== insertImportActionId && !(trachTubeSubCategoryId == patientTemplate.subCategoryId && patientTemplate.isDiscontinued && nikoPatientDetail.status == "Active") &&
                        <Button
                          disabled={isAllDisabled}
                          className="btn btn--icon"
                          icon="u-icon u-icon--update-table u-icon--sml"
                          label="Change"
                          onlyIcon={true}
                          title={"Swap"}
                          onClick={() => swapPatientTemplateItem(item, patientTemplate, nikoPatientDetail)}
                        ></Button>
                      }
                      {item.actionId === deleteImportActionId ?
                        <Button
                          className="btn btn--icon is-delete"
                          icon="u-icon u-icon--sml u-icon--undo--table"
                          label="Undelete"
                          onlyIcon={true}
                          onClick={() => setAction(item, updateImportActionId, patientTemplate)}
                          disabled={isAllDisabled}
                          title={"Undo"}
                        ></Button>
                        :
                        <Button
                          className="btn btn--icon is-delete"
                          icon={`u-icon u-icon--sml ${!item.product ? "u-icon--close--table" : "u-icon--delete--primary"}`}
                          label="Delete"
                          onlyIcon={true}
                          onClick={() => { deletePatientTemplateItem(item, patientTemplate, nikoPatientDetail) }}
                          disabled={isAllDisabled}
                          title={!item.product ? "Cancel" : "Delete"}
                        ></Button>
                      }
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {patientTemplate.itemsVisible && !patientTemplate.patientTemplateItems.some(x => !x.productId) &&
          <button className={`table--secondary__add-button${isAllDisabled ? ' is-disabled' : ''}`} onClick={() => { addEmptyItem(patientTemplate) }} disabled={isAllDisabled}>
            <span></span>
          </button>
        }
      </div>
    </React.Fragment>
  );
});

PatientTemplateTable.propTypes = {
  nikoFacilityOrderClinicalReviewPreviewViewStore: PropTypes.object.isRequired,
  patientTemplate: PropTypes.object.isRequired,
  nikoPatientDetail: PropTypes.object.isRequired
};

export default defaultTemplate(NikoFacilityOrderClinicalReviewPreviewTemplate);
